import { useEffect } from 'react'
import { UseFormHandleSubmit } from 'react-hook-form'

import { useAppSelector } from '@/redux/rootReducer'
import {
  selectCpxCard,
  selectCpxCardPracticeLocationIndex,
  selectDMPConnectTlsiConnector,
} from '@/redux/reducers/dmp-connect.reducer'

import { TlsiConnectorFormData } from './useTlsiConnectorForm'

interface UseTlsiConnectorAutoCreateParams {
  handleSubmit: UseFormHandleSubmit<TlsiConnectorFormData>
  createInsiConnector: (billingNumber: string, practiceLocation: number, practiceSetting: string) => Promise<void>
  reset: (data: Partial<TlsiConnectorFormData>) => void
}

export function useTlsiConnectorAutoCreate({ handleSubmit, createInsiConnector, reset }: UseTlsiConnectorAutoCreateParams) {
  const cpxCard = useAppSelector(selectCpxCard)
  const cpxCardPracticeLocationIndex = useAppSelector(selectCpxCardPracticeLocationIndex)
  const { billingNumber, practiceSetting, instanceUniqueId: tlsiConnectorId } = useAppSelector(selectDMPConnectTlsiConnector) ?? {}

  useEffect(() => {
    if (!billingNumber || !cpxCard || cpxCardPracticeLocationIndex === null || !practiceSetting || !!tlsiConnectorId) return

    handleSubmit(() => {
      createInsiConnector(billingNumber, cpxCardPracticeLocationIndex, practiceSetting)
      reset({ practiceLocation: cpxCardPracticeLocationIndex, practiceSetting })
    })()
  }, [billingNumber, cpxCard, cpxCardPracticeLocationIndex, practiceSetting, handleSubmit, tlsiConnectorId, createInsiConnector, reset])
}
